import { Component, OnInit } from '@angular/core';
import {Localiser} from '../../services/localiser';
import {MatDialog} from '@angular/material/dialog';
import {ReglasService} from '../../services/reglas.service';
import {regla} from '../../models/regla';
import {NewReglaComponent} from './new-regla/new-regla.component';
import {ZonaService} from '../../services/zona.service';
import {zona} from '../../models/zona';
import {DeleteReglaComponent} from "./delete-regla/delete-regla.component";
import {ProyectoService} from "../../services/proyecto.service";
import {Navigation} from "../../services/navigation.service";

@Component({
  selector: 'app-reglas',
  templateUrl: './reglas.component.html',
  styleUrls: ['./reglas.component.css']
})
export class ReglasComponent implements OnInit {

  reglas: regla[] = undefined;
  zonas: zona[] = undefined;

  constructor(public localiser: Localiser, public matDialog: MatDialog, private reglasService: ReglasService,
              private zonaService: ZonaService, public proyectoService: ProyectoService, public navigation: Navigation) {
    if (!this.proyectoService.proyectoActualCookie()) {
      proyectoService.setTrueSelectALocation("rules");
      this.toLocations();
    }  else {
      proyectoService.setLastPage("rules")
    }
  }

  ngOnInit(): void {
    this.getByIdProyecto();
  }

  getByIdProyecto() {
    this.reglasService.getPendingByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.reglas = <Array<regla>> result;
      this.reglas.sort((a, b) => a.nombre.localeCompare(b.nombre));
    })
  }

  getZonas() {
    this.zonaService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.zonas = <Array<zona>> result;
    })
  }

  newRegla(idRegla: number) {
    let dialog = this.matDialog.open(NewReglaComponent, {
      width: '100%',
      height: '95%',
      maxWidth: '95vw',
      data: { idRegla: idRegla } // Pass the parameter
    });

    dialog.afterClosed().subscribe(() => { this.getByIdProyecto() } );
  }

  deleteRegla(regla) {
    this.reglasService.setDeleteRegla(regla);
    let dialog = this.matDialog.open(DeleteReglaComponent, {
      width: '60%',
      height: '50%',
    });

    dialog.afterClosed().subscribe(() => { this.getByIdProyecto() } );
  }

  getDateFromString(dateString: string) {
    let date = new Date(+dateString);
    let day = date.getDate().toString();
    if (date.getDate().toString().length == 1) {
      day = "0" + date.getDate();
    }
    let monthI = date.getMonth() + 1;
    let month = monthI.toString();
    if (month.length == 1) {
      month = "0" + month;
    }
    let hour = date.getHours().toString();
    if (date.getHours().toString().length == 1) {
      hour = "0" + date.getHours();
    }
    let minutes = date.getMinutes().toString();
    if (date.getMinutes().toString().length == 1) {
      minutes = "0" + date.getMinutes();
    }
    return day + "/" + month + "/" + date.getFullYear() + " " + hour + ":" + minutes;
  }

  toLocations() {
    this.navigation.toLocations();
  }

}
